// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1576d3a4","484":"1ab3ac05","551":"cdc243e9","672":"e4c84ab9","842":"83506446","869":"9717036e","974":"faface78"}[chunkId] + ".chunk.js";
};